import { FC } from 'react';

import { GlobalBanner } from './GlobalBanner';
import { selectBanner } from './selectors';
import { hideBanner } from './slice';

interface GlobalBannerConnectedProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Generic Redux store state type
  useAppSelector: <T>(selector: (state: any) => T) => T;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Generic Redux dispatch type
  useAppDispatch: () => any;
}

/**
 * Connected version of GlobalBanner that integrates with Redux.
 *
 * Apps must pass their typed Redux hooks to avoid dependency issues:
 *
 * @example
 * import { GlobalBannerConnected } from '@ths/shared/store/slices/banner';
 * import { useAppSelector, useAppDispatch } from 'store/store';
 *
 * <GlobalBannerConnected
 *   useAppSelector={useAppSelector}
 *   useAppDispatch={useAppDispatch}
 * />
 */
export const GlobalBannerConnected: FC<GlobalBannerConnectedProps> = ({
  useAppSelector,
  useAppDispatch,
}) => {
  const banner = useAppSelector(selectBanner);
  const dispatch = useAppDispatch();

  return <GlobalBanner {...banner} onDismiss={() => dispatch(hideBanner())} />;
};
